// extracted by mini-css-extract-plugin
module.exports = {"loader":"MoviesContainer_loader__38ptr","component":"MoviesContainer_component__zdm4b","text":"MoviesContainer_text__5f5p7","row":"MoviesContainer_row__2qWnJ"};